// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Ue-z","summaryPar":"Ve-z","ratingCategories":"We-z","reviewerInfo":"Xe-z","reviewTypes":"Ye-z","expanded":"Ze-z"};